(() => {
  'use strict';

  const CENTER = 50;
  const CARD_SELECTOR = '[data-vault-cherry-card="true"]';
  const SURFACE_SELECTOR = '[data-vault-cherry-surface]';
  const FINE_POINTER_QUERY = '(hover: hover) and (pointer: fine)';

  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  const coordinatePercent = (coordinate, origin, length) => {
    if (!Number.isFinite(coordinate) || !Number.isFinite(origin) || !Number.isFinite(length) || length <= 0) {
      return CENTER;
    }

    return clamp(((coordinate - origin) / length) * 100, 0, 100);
  };

  const pointerPosition = (clientX, clientY, rectangle) => ({
    x: coordinatePercent(clientX, rectangle.left, rectangle.width),
    y: coordinatePercent(clientY, rectangle.top, rectangle.height),
  });

  if (typeof window !== 'undefined') {
    window.MaraschinoVaultReveal = Object.freeze({ pointerPosition });
  }

  if (typeof document === 'undefined' || typeof window === 'undefined' || window.vaultCherryRevealInitialized) {
    return;
  }

  window.vaultCherryRevealInitialized = true;

  const finePointer = window.matchMedia(FINE_POINTER_QUERY);
  let activeSurface = null;

  const surfaceForTarget = (target) => {
    if (typeof target?.closest !== 'function') {
      return null;
    }

    const directSurface = target.closest(SURFACE_SELECTOR);
    if (directSurface) {
      return directSurface;
    }

    const card = target.closest(CARD_SELECTOR);
    return typeof card?.querySelector === 'function' ? card.querySelector(SURFACE_SELECTOR) : null;
  };

  const pointInsideRectangle = (clientX, clientY, rectangle) =>
    Number.isFinite(clientX) &&
    Number.isFinite(clientY) &&
    clientX >= rectangle.left &&
    clientX <= rectangle.left + rectangle.width &&
    clientY >= rectangle.top &&
    clientY <= rectangle.top + rectangle.height;

  const clearReveal = (surface = activeSurface) => {
    if (surface) {
      surface.classList.remove('is-vault-revealing');
    }

    if (surface === activeSurface) {
      activeSurface = null;
    }
  };

  const handlePointerMove = (event) => {
    if (!finePointer.matches || (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen')) {
      clearReveal();
      return;
    }

    const surface = surfaceForTarget(event.target);
    if (!surface) {
      clearReveal();
      return;
    }

    const rectangle = surface.getBoundingClientRect();
    if (!pointInsideRectangle(event.clientX, event.clientY, rectangle)) {
      clearReveal();
      return;
    }

    if (activeSurface && activeSurface !== surface) {
      clearReveal(activeSurface);
    }

    const position = pointerPosition(event.clientX, event.clientY, rectangle);
    surface.style.setProperty('--vault-reveal-x', `${position.x}%`);
    surface.style.setProperty('--vault-reveal-y', `${position.y}%`);
    surface.classList.add('is-vault-revealing');
    activeSurface = surface;
  };

  const handlePointerOut = (event) => {
    const surface = surfaceForTarget(event.target);
    if (!surface || (event.relatedTarget && surface.contains(event.relatedTarget))) {
      return;
    }

    clearReveal(surface);
  };

  const handlePointerCapabilityChange = () => {
    if (!finePointer.matches) {
      clearReveal();
    }
  };

  document.addEventListener('pointermove', handlePointerMove, { passive: true });
  document.addEventListener('pointerout', handlePointerOut, { passive: true });

  if (typeof finePointer.addEventListener === 'function') {
    finePointer.addEventListener('change', handlePointerCapabilityChange);
  } else if (typeof finePointer.addListener === 'function') {
    finePointer.addListener(handlePointerCapabilityChange);
  }
})();
